// Optimistic equestrian-result verify toggle. Mirrors useMarkVerify: optimistic
// set + revert-on-error, hitting the per-result verify endpoint
// (POST /equestrian-results/athlete/{userId}/{id}/verify) which returns the
// updated row (a plain row, NO summary). The read-only card's summary comes from
// the list endpoint's {results, summary}; verify only flips the row's `verified`
// in the results array, so the derived W-L / points totals are unaffected.
// Staff/partner only — the caller gates rendering on perms.canVerify.
import { useState } from 'react';
import axios from 'axios';

export default function useResultVerify({ userId, apiUrl, getConfig, setResults }) {
  const [busyId, setBusyId] = useState(null);

  const toggleVerify = async (r) => {
    const next = !r.verified;
    setBusyId(r.id);
    setResults(list => list.map(x => (x.id === r.id ? { ...x, verified: next } : x)));
    try {
      const res = await axios.post(
        `${apiUrl}/equestrian-results/athlete/${userId}/${r.id}/verify`, {}, getConfig());
      setResults(list => list.map(x => (x.id === r.id ? { ...x, ...res.data } : x)));
    } catch {
      // revert
      setResults(list => list.map(x => (x.id === r.id ? { ...x, verified: r.verified } : x)));
    } finally {
      setBusyId(null);
    }
  };

  return { toggleVerify, busyId };
}
